import React, { useState, useContext, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.css"; // Import global styles
import SignIn from "./SignIn"; // Import Sign In component
import SignUp from "./SignUp"; // Import Sign Up component
import UserProfile from "./UserProfile"; // Import User Profile component
import Popup1 from "./Popup1"; // Import User Preference component
import ProjectAdmin from "./ProjectAdmin"; // Import Project Admin component
import WebsiteLogo from "../../images/WebsiteLogo.png"; // Import the logo
import { UserContext } from "../context/UserContext"; // Import UserContext
import axios from "axios";
import Donate from "./Donate"; // Import Donate component
import { FaTimes, FaBars } from "react-icons/fa"; // Import close icon for popup and bars icon
import VideosAdmin from "./VideosAdmin";
import FundingReport from "./FundingReport";
import CharityAdmin from "./CharityAdmin";
import CharityReport from "./CharityReport";
import VotedBillsReport from "./VotedBillsReport"; // Add this import
import AdminCandidatesPopup from "./AdminCandidatesPopup"; // Import the new popup component
import ReceiptReport from './ReceiptReport'; // Updated import name
import { useNavigate, useLocation } from 'react-router-dom'; // Add this import
import Quiz from "./Quiz"; // Import Quiz component

const Header = () => {
  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showUserProfile, setShowUserProfile] = useState(false); // State for User Profile
  const [showUserPreference, setShowUserPreference] = useState(false); // State for User Preference
  const [showProjectAdmin, setShowProjectAdmin] = useState(false); // State for Project Admin
  const [showFundingReport, setShowFundingReport] = useState(false); // Funding Report State
  const [showVideosAdmin, setShowVideosAdmin] = useState(false); // Videos Admin State
  const [showDonatePopup, setShowDonatePopup] = useState(false); // State for Donate popup
  const [profileDropdown, setProfileDropdown] = useState(false); // Dropdown for profile
  const [isLaptop, setIsLaptop] = useState(window.innerWidth > 1024); // Detect if device is a laptop
  const [isLandscape, setIsLandscape] = useState(() => window.innerWidth > window.innerHeight); // Detect if screen is in landscape mode
  const [showCharityAdmin, setShowCharityAdmin] = useState(false); // Add this state
  const [showVotedBillsReport, setShowVotedBillsReport] = useState(false); // Add this line
  const [showCharityReport, setShowCharityReport] = useState(false);
  const [showCandidatesAdmin, setShowCandidatesAdmin] = useState(false); // Add state for candidates admin popup
  const [showReceiptReport, setShowReceiptReport] = useState(false); // Updated state name
  const { firstName, isLoggedIn, setIsLoggedIn, setEmailId, emailId, quizFinished } =
    useContext(UserContext); // Fetch user details from context
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState(1);
  const [initialDistance, setInitialDistance] = useState(null);
  const navigate = useNavigate(); // Add navigate hook
  const [showVisionDropdown, setShowVisionDropdown] = useState(false); // Add state for vision dropdown
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileVisionDropdown, setShowMobileVisionDropdown] = useState(false);
  const mobileMenuRef = useRef(null);
  const location = useLocation();
  const [showQuiz, setShowQuiz] = useState(false); // Add state for Quiz

  const dropdownRef = useRef(null); // Reference for the dropdown menu

  const handleSignInClick = () => setShowSignIn(true);
  const handleSignUpClick = () => {
    setShowSignUp(true); // Directly show signup popup
  };
  const handleUserProfileClick = () => setShowUserProfile(true);
  const handleUserPreferenceClick = () => setShowUserPreference(true);
  const handleProjectAdminClick = () => setShowProjectAdmin(true); // Open Project Admin popup
  const handleCandidatesAdminClick = () => setShowCandidatesAdmin(true); // Open Candidates Admin popup

  const handleLogout = () => {
    setIsLoggedIn(false); // Log the user out
    setEmailId(""); // Clear the user's email
    setShowUserProfile(false);
    setShowUserPreference(false);
    setShowProjectAdmin(false);
    setProfileDropdown(false); // Close profile dropdown
    // Remove locally stored user information
    localStorage.removeItem("emailId");
    localStorage.removeItem("token");
    localStorage.removeItem("firstName");
  };

  const handleClose = () => {
    setShowSignIn(false);
    setShowSignUp(false);
    setShowUserProfile(false);
    setShowUserPreference(false);
    setShowProjectAdmin(false);
    setShowDonatePopup(false);
    setShowFundingReport(false);
    setShowVideosAdmin(false);
    setShowCharityAdmin(false);
    setShowVotedBillsReport(false);
    setShowCharityReport(false);
    setShowCandidatesAdmin(false); // Close candidates admin popup
    setShowReceiptReport(false); // Updated state name
  };

  const checkFirstTime = async () => {
    try {
      // Only check firsttime value, don't update it yet
      const response = await axios.get(
        "/api/check-firsttime",
        {
          params: { email_id: emailId },
        }
      );

      if (response.data.firsttime === 1) {
        setShowUserPreference(true);
      }
    } catch (error) {
      console.error("Error checking firsttime:", error);
    }
  };

  const toggleDropdown = () => {
    setProfileDropdown(!profileDropdown);
  };

  const handleDonateClick = () => {
    setShowDonatePopup(true); // Open the Donate popup
  };

  // Automatically show Popup1 when the user logs in
  useEffect(() => {
    if (isLoggedIn) {
      setShowSignIn(false); // Force close SignIn modal when user is logged in
      setShowSignUp(false); // Force close SignUp modal when user is logged in
      checkFirstTime(); // Check and handle firsttime logic
    }
  }, [isLoggedIn]);

  // Detect screen size and orientation changes
  useEffect(() => {
    const handleResize = () => {
      setIsLaptop(window.innerWidth > 1024); // Update laptop detection
      setIsLandscape(() => window.innerWidth > window.innerHeight); // Update landscape mode
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProfileDropdown(false);
      }
    };

    if (profileDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileDropdown]);

  // Custom scrollbar styles
  const styles = `
    .profile-dropdown-menu::-webkit-scrollbar {
      width: 6px;
    }

    .profile-dropdown-menu::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    .profile-dropdown-menu::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 3px;
    }

    .profile-dropdown-menu::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  `;

  // Move useEffect inside the component
  useEffect(() => {
    if (window.innerWidth <= 926) {
      const styleSheet = document.createElement("style");
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
      return () => {
        document.head.removeChild(styleSheet);
      };
    }
  }, []);

  // Add the touch handlers from TutorialList
  const handleTouchStart = (e) => {
    if (window.innerWidth <= 926) {
      if (e.touches.length === 2) {
        const distance = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        setInitialDistance(distance);
      } else {
        const touch = e.touches[0];
        setStartPosition({
          x: touch.clientX - position.x,
          y: touch.clientY - position.y
        });
      }
    }
  };

  const handleTouchMove = (e) => {
    if (window.innerWidth <= 926) {
      e.preventDefault();
      if (e.touches.length === 2) {
        const distance = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        if (initialDistance) {
          const newScale = scale * (distance / initialDistance);
          setScale(Math.min(Math.max(0.5, newScale), 2));
          setInitialDistance(distance);
        }
      } else {
        const touch = e.touches[0];
        setPosition({
          x: touch.clientX - startPosition.x,
          y: touch.clientY - startPosition.y
        });
      }
    }
  };

  const handleTouchEnd = () => {
    setInitialDistance(null);
  };

  const getYouTubeVideoId = (url) => {
    if (!url) return '';
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : '';
  };

  // Modified handlers for vision options
  const handleVotersClick = () => {
    navigate('/', { 
      state: { 
        initialSelection: 'voters',
        showVotersContent: true 
      }
    });
    setShowVisionDropdown(false);
  };

  const handlePoliticiansClick = () => {
    navigate('/', { 
      state: { 
        initialSelection: 'politicians',
        showPoliticiansContent: true 
      }
    });
    setShowVisionDropdown(false);
  };

  // Add click handler for logo
  const handleLogoClick = () => {
    navigate('/main');
  };

  // Add handler for Testimonials button
  const handleTestimonialsClick = () => {
    navigate('/testimonials');
  };

  // Add new function to render mobile header before login
  const renderMobilePreLogin = () => (
    <div className="header" style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px",
      width: "100%",
      boxShadow: "none"
    }}>
      <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        {isLaptop ? (
          <img
            src={WebsiteLogo}
            alt="UrVote Matters Logo"
            className="logo-image"
            style={{ height: "60px", width: "auto" }}
          />
        ) : isLandscape ? (
          <h1
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              color: "white",
              margin: "0",
            }}
          >
            UrVote
          </h1>
        ) : (
          <img
            src={WebsiteLogo}
            alt="UrVote Matters Logo"
            className="logo-image"
            style={{ height: "50px", width: "auto" }}
          />
        )}
      </div>
      
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        gap: "10px"
      }}>
        {/* Commenting out the Quiz button
        <button
          className="btn-get-started scrollto"
          onClick={handleQuizClick}
          style={{
            padding: '8px 15px',
            fontSize: '0.95rem',
            backgroundColor: '#dc3545',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
            width: '140px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            animation: 'pulseAndGlow 2s infinite',
            transition: 'all 0.3s ease-in-out',
            background: 'linear-gradient(45deg, #dc3545, #c82333)',
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 6px 15px rgba(220,53,69,0.6), 0 0 20px rgba(220,53,69,0.3)';
            e.target.style.background = 'linear-gradient(45deg, #c82333, #dc3545)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 6px rgba(220,53,69,0.2)';
            e.target.style.background = 'linear-gradient(45deg, #dc3545, #c82333)';
          }}
        >
          <span style={{ 
            fontWeight: 'bold', 
            textTransform: 'uppercase', 
            fontSize: '1rem',
            color: '#fff',
            textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
            whiteSpace: 'nowrap'
          }}>
            CLICK TO QUIZ
          </span>
        </button>
        */}
        <button
          className="btn-get-started scrollto"
          onClick={handleSignInClick}
        >
          Login
        </button>
        <button
          className="btn-get-started scrollto"
          onClick={handleSignUpClick}
        >
          SignUp
        </button>
      </div>
    </div>
  );

  // Add new function to render mobile header after login
  const renderMobilePostLogin = () => (
    <div className="header" style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "5px 10px",
      width: "100%",
      boxShadow: "none"
    }}>
      <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        {isLaptop ? (
          <img
            src={WebsiteLogo}
            alt="UrVote Matters Logo"
            className="logo-image"
            style={{ height: "60px", width: "auto" }}
          />
        ) : isLandscape ? (
          <h1
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              color: "white",
              margin: "0",
            }}
          >
            UrVote
          </h1>
        ) : (
          <img
            src={WebsiteLogo}
            alt="UrVote Matters Logo"
            className="logo-image"
            style={{ height: "50px", width: "auto" }}
          />
        )}
      </div>
      
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        gap: "8px",
        position: "relative"
      }}>
        {/* Commenting out the Quiz button condition
        {!quizFinished && (
          <button
            className="btn-get-started scrollto"
            onClick={handleQuizClick}
            style={{
              padding: '8px 15px',
              fontSize: '0.95rem',
              backgroundColor: '#dc3545',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
              width: '140px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              animation: 'pulseAndGlow 2s infinite',
              transition: 'all 0.3s ease-in-out',
              background: 'linear-gradient(45deg, #dc3545, #c82333)',
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 6px 15px rgba(220,53,69,0.6), 0 0 20px rgba(220,53,69,0.3)';
              e.target.style.background = 'linear-gradient(45deg, #c82333, #dc3545)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 4px 6px rgba(220,53,69,0.2)';
              e.target.style.background = 'linear-gradient(45deg, #dc3545, #c82333)';
            }}
          >
            <span style={{ 
              fontWeight: 'bold', 
              textTransform: 'uppercase', 
              fontSize: '1rem',
              color: '#fff',
              textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
              whiteSpace: 'nowrap'
            }}>
              CLICK TO QUIZ
            </span>
          </button>
        )}
        */}
        <div className="profile-dropdown" ref={dropdownRef}>
          <button 
            className="profile-dropdown-btn"
            onClick={toggleDropdown}
            style={{ marginRight: "10px" }}
          >
            {firstName} <span>▼</span>
          </button>
          {profileDropdown && (
            <ul
              className="profile-dropdown-menu"
              style={{
                position: "fixed", // Fixed position for dropdown
                top: isLaptop ? "80px" : "30px", // Conditional top position based on device type
                right: "10px", // Align to the right
                backgroundColor: "white",
                borderRadius: "5px",
                listStyleType: "none",
                padding: "10px",
                margin: "0",
                width: "200px", // Consistent dropdown width
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                zIndex: 9999, // Ensure dropdown is above everything
                maxHeight: window.innerWidth <= 926 ? "70vh" : "auto", // Add max height for mobile
                overflowY: window.innerWidth <= 926 ? "auto" : "visible", // Add scroll for mobile
                overflowX: "hidden"
              }}
            >
              <li style={{ marginBottom: "10px" }}>
                <a
                  href="#"
                  onClick={() => {
                    handleUserProfileClick(); // Open the User Profile
                    setProfileDropdown(false); // Close the dropdown
                    setTimeout(() => setProfileDropdown(false), 0); // Close dropdown
                  }}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    display: "block",
                    padding: "5px 10px",
                    borderRadius: "3px",
                  }}
                >
                  User Profile
                </a>
              </li>
              <hr
                style={{
                  margin: "5px 0",
                  borderColor: "#d0d0d0", // Darker line color
                  borderWidth: "2px", // Thicker line
                }}
              />
              <li style={{ marginBottom: "10px" }}>
                <a
                  href="#"
                  onClick={() => {
                    handleUserPreferenceClick();
                    setProfileDropdown(false);
                    setTimeout(() => setProfileDropdown(false), 0);
                  }}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    display: "block",
                    padding: "5px 10px",
                    borderRadius: "3px",
                  }}
                >
                  Category Preference / Candidate Verification
                </a>
              </li>

              <hr
                style={{
                  margin: "5px 0",
                  borderColor: "#d0d0d0", // Darker line color
                  borderWidth: "2px", // Thicker line
                }}
              />
               {/* Voted Bills Report */}
              <li style={{ marginBottom: "10px" }}>
                <a href="#" onClick={() => {
                  setShowVotedBillsReport(true);
                  setProfileDropdown(false);
                  setTimeout(() => setProfileDropdown(false), 0);
                }} style={{
                  textDecoration: "none",
                  color: "black",
                  display: "block",
                  padding: "5px 10px",
                  borderRadius: "3px",
                }}>
                  Voted Bills Report
                </a>
              </li>
              
              {/* Funding Report and Charity Report (only for specific email) */}
              {emailId === "info@urcommunity.com.au" ? (
                <>
                  <hr style={{
                    margin: "5px 0",
                    borderColor: "#d0d0d0",
                    borderWidth: "2px",
                  }} />
                  <li style={{ marginBottom: "10px" }}>
                    <a href="#" onClick={() => { 
                      setShowFundingReport(true); 
                      setProfileDropdown(false); 
                      setTimeout(() => setProfileDropdown(false), 0);
                    }} style={{
                      textDecoration: "none",
                      color: "black",
                      display: "block",
                      padding: "5px 10px",
                      borderRadius: "3px",
                    }}>
                      Funding Report
                    </a>
                  </li>
                  <hr style={{
                    margin: "5px 0",
                    borderColor: "#d0d0d0",
                    borderWidth: "2px",
                  }} />
                  <li style={{ marginBottom: "10px" }}>
                    <a href="#" onClick={() => { 
                      setShowCharityReport(true); 
                      setProfileDropdown(false); 
                      setTimeout(() => setProfileDropdown(false), 0);
                    }} style={{
                      textDecoration: "none",
                      color: "black",
                      display: "block",
                      padding: "5px 10px",
                      borderRadius: "3px",
                    }}>
                      Charity Report
                    </a>
                  </li>
                  <hr style={{
                    margin: "5px 0",
                    borderColor: "#d0d0d0",
                    borderWidth: "2px",
                  }} />
                  <li style={{ marginBottom: "10px" }}>
                    <a href="#" onClick={() => { 
                      handleCandidatesAdminClick(); // Use the function to open the popup
                      setProfileDropdown(false); 
                      setTimeout(() => setProfileDropdown(false), 0);
                    }} style={{
                      textDecoration: "none",
                      color: "black",
                      display: "block",
                      padding: "5px 10px",
                      borderRadius: "3px",
                    }}>
                      Manage Candidates
                    </a>
                  </li>
                  <hr style={{
                    margin: "5px 0",
                    borderColor: "#d0d0d0",
                    borderWidth: "2px",
                  }} />
                  <li style={{ marginBottom: "10px" }}>
                    <a href="#" onClick={() => { 
                      setShowReceiptReport(true); 
                      setProfileDropdown(false); 
                      setTimeout(() => setProfileDropdown(false), 0);
                    }} style={{
                      textDecoration: "none",
                      color: "black",
                      display: "block",
                      padding: "5px 10px",
                      borderRadius: "3px",
                    }}>
                      Receipt Report
                    </a>
                  </li>
                </>
              ) : null}
              {/* Project Admin */}
              <hr style={{
                margin: "5px 0",
                borderColor: "#d0d0d0",
                borderWidth: "2px",
              }} />
              <li style={{ marginBottom: "10px" }}>
                <a
                  href="#"
                  onClick={() => {
                    handleProjectAdminClick();
                    setProfileDropdown(false);
                    setTimeout(() => setProfileDropdown(false), 0);
                  }}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    display: "block",
                    padding: "5px 10px",
                    borderRadius: "3px",
                  }}
                >
                  Project Admin
                </a>
              </li>
              <hr style={{
                margin: "5px 0",
                borderColor: "#d0d0d0",
                borderWidth: "2px",
              }} />
              {/* Videos Admin (only for specific email) */}
              {emailId === "urvote_tutorials@urcommunity.com.au" ? (
                <>
                  <li style={{ marginBottom: "10px" }}>
                    <a href="#" onClick={() => { 
                      setShowVideosAdmin(true); 
                      setProfileDropdown(false); 
                      setTimeout(() => setProfileDropdown(false), 0);
                    }} style={{
                      textDecoration: "none",
                      color: "black",
                      display: "block",
                      padding: "5px 10px",
                      borderRadius: "3px",
                    }}>
                      Videos Admin
                    </a>
                  </li>
                  <hr style={{
                    margin: "5px 0",
                    borderColor: "#d0d0d0",
                    borderWidth: "2px",
                  }} />
                </>
              ) : null}
              
              {/* Charity Admin */}
              <li style={{ marginBottom: "10px" }}>
                <a
                  href="#"
                  onClick={() => {
                    setShowCharityAdmin(true);
                    setProfileDropdown(false);
                    setTimeout(() => setProfileDropdown(false), 0);
                  }}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    display: "block",
                    padding: "5px 10px",
                    borderRadius: "3px",
                  }}
                >
                  Charity Admin
                </a>
              </li>
              <hr style={{
                margin: "5px 0",
                borderColor: "#d0d0d0",
                borderWidth: "2px",
              }} />
              <li>
                <a
                  href="#"
                  onClick={() => {
                    handleLogout();
                    setProfileDropdown(false);
                    setTimeout(() => setProfileDropdown(false), 0);
                  }}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    display: "block",
                    padding: "5px 10px",
                    borderRadius: "3px",
                  }}
                >
                  Logout
                </a>
              </li>
            </ul>
          )}
        </div>
        <div ref={mobileMenuRef}>
          <FaBars 
            size={24} 
            color="white"
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            style={{ 
              cursor: "pointer",
              marginLeft: "5px"
            }}
          />
          {showMobileMenu && (
            <div style={{
              position: "fixed",
              top: "45px",
              right: "10px",
              backgroundColor: "white",
              borderRadius: "5px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              padding: "10px",
              minWidth: "200px",
              zIndex: 99999,
              maxHeight: "calc(100vh - 100px)",
              overflowY: "auto",
              overflowX: "hidden",
              marginTop: "5px"
            }}>
              <div
                onClick={() => {
                  navigate('/');
                  setShowMobileMenu(false);
                }}
                style={{
                  padding: "10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee"
                }}
              >
                Home
              </div>
              <div
                style={{
                  borderBottom: "1px solid #eee"
                }}
              >
                <div
                  onClick={() => setShowMobileVisionDropdown(!showMobileVisionDropdown)}
                  style={{
                    padding: "10px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  Vision 
                  <span style={{ 
                    color: "#000",
                    transform: showMobileVisionDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                    display: 'inline-block'
                  }}>
                    ▼
                  </span>
                </div>
                {showMobileVisionDropdown && (
                  <div style={{
                    backgroundColor: "white",
                    padding: "5px 0",
                    position: "relative",
                    zIndex: 99999
                  }}>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleVotersClick();
                        setShowMobileMenu(false);
                      }}
                      style={{
                        padding: "8px 20px",
                        cursor: "pointer",
                        borderTop: "1px solid #eee"
                      }}
                    >
                      Voters
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePoliticiansClick();
                        setShowMobileMenu(false);
                      }}
                      style={{
                        padding: "8px 20px",
                        cursor: "pointer",
                        borderTop: "1px solid #eee"
                      }}
                    >
                      Politicians
                    </div>
                  </div>
                )}
              </div>
              <div
                onClick={() => {
                  navigate('/testimonials');  // Assuming you have a testimonials route
                  setShowMobileMenu(false);
                }}
                style={{
                  padding: "10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee"
                }}
              >
                Testimonials
              </div>
              <div
                onClick={() => {
                  handleDonateClick();
                  setShowMobileMenu(false);
                }}
                style={{
                  padding: "10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee"
                }}
              >
                Donate
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
  
  // Add click outside handler for mobile menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setShowMobileMenu(false);
        setShowMobileVisionDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSwitchToSignIn = () => {
    setShowSignUp(false);
    setShowSignIn(true);
  };

  // Add new handler for Quiz button
  const handleQuizButtonClick = () => {
    setShowQuiz(true);
  };

  // Add this new function
  const handleQuizClick = () => {
    if (isLoggedIn) {
      setShowQuiz(true);
    } else {
      setShowSignIn(true);
    }
  };

  return (
    <header className="header" style={window.innerWidth <= 926 ? { boxShadow: "none" } : {}}>
      {window.innerWidth <= 926 ? (
        // Mobile view
        isLoggedIn ? renderMobilePostLogin() : renderMobilePreLogin()
      ) : (
        // Desktop view
        <>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
              {isLaptop ? (
                <img
                  src={WebsiteLogo}
                  alt="UrVote Matters Logo"
                  className="logo-image"
                  style={{ height: "100px", width: "auto" }}
                />
              ) : isLandscape ? (
                <h1
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "white",
                    margin: "0",
                  }}
                >
                  UrVote
                </h1>
              ) : (
                <img
                  src={WebsiteLogo}
                  alt="UrVote Matters Logo"
                  className="logo-image"
                  style={{ height: "100px", width: "auto" }}
                />
              )}
            </div>
            {isLaptop && (
              <div style={{
                marginLeft: window.innerWidth <= 1200 ? '20px' : '100px', // Responsive margin
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                textAlign: 'center',
                minWidth: '350px',
                maxWidth: '450px'
              }}>
                {/* Commenting out the holiday text
                <span style={{
                  fontSize: window.innerWidth <= 1366 ? '32px' : '38px',
                  fontWeight: 'bold',
                  lineHeight: '1.2',
                  letterSpacing: '1.2px',
                  textAlign: 'center',
                  whiteSpace: 'nowrap'
                }}>
                  WIN ONE OF HUNDREDS
                </span>
                <span style={{
                  fontSize: window.innerWidth <= 1366 ? '28px' : '32px',
                  fontWeight: 'bold',
                  lineHeight: '1.2',
                  letterSpacing: '1.2px',
                  marginTop: '5px',
                  textAlign: 'center',
                  whiteSpace: 'nowrap'
                }}>
                  OF GREAT HOLIDAYS !*
                </span>
                */}
              </div>
            )}
          </div>
          <div className="header-buttons">
            {/* Apply to Quiz button - commenting out the entire block
            {(!isLoggedIn || (isLoggedIn && !quizFinished)) && (
              <div className="dropdown" style={{ position: "relative", marginRight: "2px" }}>
                <button
                  style={{
                    padding: '8px 15px',
                    fontSize: '0.95rem',
                    backgroundColor: '#dc3545',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                    width: '180px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    animation: 'pulseAndGlow 2s infinite',
                    transition: 'all 0.3s ease-in-out',
                    background: 'linear-gradient(45deg, #dc3545, #c82333)',
                  }}
                  onClick={handleQuizButtonClick}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 6px 15px rgba(220,53,69,0.6), 0 0 20px rgba(220,53,69,0.3)';
                    e.target.style.background = 'linear-gradient(45deg, #c82333, #dc3545)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 4px 6px rgba(220,53,69,0.2)';
                    e.target.style.background = 'linear-gradient(45deg, #dc3545, #c82333)';
                  }}
                >
                  <span style={{ 
                    fontWeight: 'bold', 
                    textTransform: 'uppercase', 
                    fontSize: '1rem',
                    color: '#fff',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
                    whiteSpace: 'nowrap'
                  }}>
                    CLICK TO QUIZ
                  </span>
                </button>
              </div>
            )}
            */}

            {/* Existing Home button */}
            {location.pathname !== '/' && (
              <div className="dropdown" style={{ position: "relative", marginRight: "2px" }}>
                <button
                  className="btn-get-started scrollto"
                  onClick={() => navigate('/')}
                  style={{ position: "relative" }}
                >
                  Home
                </button>
              </div>
            )}

            {/* Vision button with dropdown */}
            <div className="dropdown" style={{ 
              position: "relative", 
              marginRight: "2px",
              display: "inline-block"
            }}>
              <button
                className="btn-get-started scrollto"
                onClick={() => setShowVisionDropdown(!showVisionDropdown)}
                onBlur={() => setTimeout(() => setShowVisionDropdown(false), 200)}
                style={{ position: "relative" }}
              >
                Vision ▼
              </button>
              
              {showVisionDropdown && (
                <div style={{
                  position: "absolute",
                  top: "100%",
                  left: "0",
                  backgroundColor: "white",
                  boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                  borderRadius: "5px",
                  zIndex: 1000,
                  minWidth: "160px",
                  marginTop: "5px"
                }}>
                  <button
                    onClick={handleVotersClick}
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "12px 16px",
                      textAlign: "left",
                      border: "none",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                      color: "#333",
                      fontSize: "14px",
                      borderRadius: "5px 5px 0 0",
                      transition: "background-color 0.3s"
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#f1f1f1"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}
                  >
                    Voters
                  </button>
                  <button
                    onClick={handlePoliticiansClick}
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "12px 16px",
                      textAlign: "left",
                      border: "none",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                      color: "#333",
                      fontSize: "14px",
                      borderRadius: "0 0 5px 5px",
                      transition: "background-color 0.3s"
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#f1f1f1"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}
                  >
                    Politicians
                  </button>
                </div>
              )}
            </div>

            {/* Testimonials button */}
            <div className="dropdown" style={{ 
              position: "relative", 
              
            }}>
              <button
                className="btn-get-started scrollto"
                onClick={handleTestimonialsClick}
                style={{ position: "relative" }}
              >
                Testimonials
              </button>
            </div>

            {/* Donate Button */}
            <div className="dropdown" style={{ 
              position: "relative",
              
            }}>
              <button
                className="btn-get-started scrollto"
                onClick={handleDonateClick}
                style={{ position: "relative" }}
              >
                Donate
              </button>
            </div>

            {isLoggedIn ? (
              <div
                className="profile-dropdown"
                onClick={toggleDropdown} // Toggle the dropdown
                ref={dropdownRef} // Attach ref to the dropdown
              >
                <button className="profile-dropdown-btn">
                  {firstName} <span>▼</span> {/* Add a dropdown arrow */}
                </button>
                {profileDropdown && (
                  <ul
                    className="profile-dropdown-menu"
                    style={{
                      position: "fixed", // Fixed position for dropdown
                      top: isLaptop ? "80px" : "30px", // Conditional top position based on device type
                      right: "10px", // Align to the right
                      backgroundColor: "white",
                      borderRadius: "5px",
                      listStyleType: "none",
                      padding: "10px",
                      margin: "0",
                      width: "200px", // Consistent dropdown width
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      zIndex: 9999, // Ensure dropdown is above everything
                      maxHeight: window.innerWidth <= 926 ? "70vh" : "auto", // Add max height for mobile
                      overflowY: window.innerWidth <= 926 ? "auto" : "visible", // Add scroll for mobile
                      overflowX: "hidden"
                    }}
                  >
                    <li style={{ marginBottom: "10px" }}>
                      <a
                        href="#"
                        onClick={() => {
                          handleUserProfileClick(); // Open the User Profile
                          setProfileDropdown(false); // Close the dropdown
                          setTimeout(() => setProfileDropdown(false), 0); // Close dropdown
                        }}
                        style={{
                          textDecoration: "none",
                          color: "black",
                          display: "block",
                          padding: "5px 10px",
                          borderRadius: "3px",
                        }}
                      >
                        User Profile
                      </a>
                    </li>
                    <hr
                      style={{
                        margin: "5px 0",
                        borderColor: "#d0d0d0", // Darker line color
                        borderWidth: "2px", // Thicker line
                      }}
                    />
                    <li style={{ marginBottom: "10px" }}>
                      <a
                        href="#"
                        onClick={() => {
                          handleUserPreferenceClick();
                          setProfileDropdown(false);
                          setTimeout(() => setProfileDropdown(false), 0);
                        }}
                        style={{
                          textDecoration: "none",
                          color: "black",
                          display: "block",
                          padding: "5px 10px",
                          borderRadius: "3px",
                        }}
                      >
                        Category Preference / Candidate Verification
                      </a>
                    </li>

                    <hr
                      style={{
                        margin: "5px 0",
                        borderColor: "#d0d0d0", // Darker line color
                        borderWidth: "2px", // Thicker line
                      }}
                    />
                     {/* Voted Bills Report */}
                    <li style={{ marginBottom: "10px" }}>
                      <a href="#" onClick={() => {
                        setShowVotedBillsReport(true);
                        setProfileDropdown(false);
                        setTimeout(() => setProfileDropdown(false), 0);
                      }} style={{
                        textDecoration: "none",
                        color: "black",
                        display: "block",
                        padding: "5px 10px",
                        borderRadius: "3px",
                      }}>
                        Voted Bills Report
                      </a>
                    </li>
                    
                    {/* Funding Report and Charity Report (only for specific email) */}
                    {emailId === "info@urcommunity.com.au" ? (
                      <>
                        <hr style={{
                          margin: "5px 0",
                          borderColor: "#d0d0d0",
                          borderWidth: "2px",
                        }} />
                        <li style={{ marginBottom: "10px" }}>
                          <a href="#" onClick={() => { 
                            setShowFundingReport(true); 
                            setProfileDropdown(false); 
                            setTimeout(() => setProfileDropdown(false), 0);
                          }} style={{
                            textDecoration: "none",
                            color: "black",
                            display: "block",
                            padding: "5px 10px",
                            borderRadius: "3px",
                          }}>
                            Funding Report
                          </a>
                        </li>
                        <hr style={{
                          margin: "5px 0",
                          borderColor: "#d0d0d0",
                          borderWidth: "2px",
                        }} />
                        <li style={{ marginBottom: "10px" }}>
                          <a href="#" onClick={() => { 
                            setShowCharityReport(true); 
                            setProfileDropdown(false); 
                            setTimeout(() => setProfileDropdown(false), 0);
                          }} style={{
                            textDecoration: "none",
                            color: "black",
                            display: "block",
                            padding: "5px 10px",
                            borderRadius: "3px",
                          }}>
                            Charity Report
                          </a>
                        </li>
                        <hr style={{
                          margin: "5px 0",
                          borderColor: "#d0d0d0",
                          borderWidth: "2px",
                        }} />
                        <li style={{ marginBottom: "10px" }}>
                          <a href="#" onClick={() => { 
                            handleCandidatesAdminClick(); // Use the function to open the popup
                            setProfileDropdown(false); 
                            setTimeout(() => setProfileDropdown(false), 0);
                          }} style={{
                            textDecoration: "none",
                            color: "black",
                            display: "block",
                            padding: "5px 10px",
                            borderRadius: "3px",
                          }}>
                            Manage Candidates
                          </a>
                        </li>
                        <hr style={{
                          margin: "5px 0",
                          borderColor: "#d0d0d0",
                          borderWidth: "2px",
                        }} />
                        <li style={{ marginBottom: "10px" }}>
                          <a href="#" onClick={() => { 
                            setShowReceiptReport(true); 
                            setProfileDropdown(false); 
                            setTimeout(() => setProfileDropdown(false), 0);
                          }} style={{
                            textDecoration: "none",
                            color: "black",
                            display: "block",
                            padding: "5px 10px",
                            borderRadius: "3px",
                          }}>
                            Receipt Report
                          </a>
                        </li>
                      </>
                    ) : null}
                    {/* Project Admin */}
                    <hr style={{
                      margin: "5px 0",
                      borderColor: "#d0d0d0",
                      borderWidth: "2px",
                    }} />
                    <li style={{ marginBottom: "10px" }}>
                      <a
                        href="#"
                        onClick={() => {
                          handleProjectAdminClick();
                          setProfileDropdown(false);
                          setTimeout(() => setProfileDropdown(false), 0);
                        }}
                        style={{
                          textDecoration: "none",
                          color: "black",
                          display: "block",
                          padding: "5px 10px",
                          borderRadius: "3px",
                        }}
                      >
                        Project Admin
                      </a>
                    </li>
                    <hr style={{
                      margin: "5px 0",
                      borderColor: "#d0d0d0",
                      borderWidth: "2px",
                    }} />
                    {/* Videos Admin (only for specific email) */}
                    {emailId === "urvote_tutorials@urcommunity.com.au" ? (
                      <>
                        <li style={{ marginBottom: "10px" }}>
                          <a href="#" onClick={() => { 
                            setShowVideosAdmin(true); 
                            setProfileDropdown(false); 
                            setTimeout(() => setProfileDropdown(false), 0);
                          }} style={{
                            textDecoration: "none",
                            color: "black",
                            display: "block",
                            padding: "5px 10px",
                            borderRadius: "3px",
                          }}>
                            Videos Admin
                          </a>
                        </li>
                        <hr style={{
                          margin: "5px 0",
                          borderColor: "#d0d0d0",
                          borderWidth: "2px",
                        }} />
                      </>
                    ) : null}
                    
                    {/* Charity Admin */}
                    <li style={{ marginBottom: "10px" }}>
                      <a
                        href="#"
                        onClick={() => {
                          setShowCharityAdmin(true);
                          setProfileDropdown(false);
                          setTimeout(() => setProfileDropdown(false), 0);
                        }}
                        style={{
                          textDecoration: "none",
                          color: "black",
                          display: "block",
                          padding: "5px 10px",
                          borderRadius: "3px",
                        }}
                      >
                        Charity Admin
                      </a>
                    </li>
                    <hr style={{
                      margin: "5px 0",
                      borderColor: "#d0d0d0",
                      borderWidth: "2px",
                    }} />
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          handleLogout();
                          setProfileDropdown(false);
                          setTimeout(() => setProfileDropdown(false), 0);
                        }}
                        style={{
                          textDecoration: "none",
                          color: "black",
                          display: "block",
                          padding: "5px 10px",
                          borderRadius: "3px",
                        }}
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                )}
              </div>
            ) : (
              <>
                <button
                  className="btn-get-started scrollto"
                  onClick={handleSignInClick}
                >
                  Sign In
                </button>
                <button
                  className="btn-get-started scrollto"
                  onClick={handleSignUpClick}
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
        </>
      )}

      {/* Conditionally Render Components */}
      {showSignIn && (
        <SignIn 
          onClose={handleClose} 
          onSignUpClick={() => {
            setShowSignIn(false);
            setShowSignUp(true);
          }}
        />
      )}
      {showSignUp && (
        <SignUp 
          showModal={showSignUp} 
          onClose={handleClose}
          onSignInClick={handleSwitchToSignIn}
        />
      )}
      {showUserProfile && <UserProfile onClose={handleClose} />}
      {showUserPreference && <Popup1 onClose={handleClose} />}
      {showProjectAdmin && <ProjectAdmin onClose={handleClose} />}
      {showFundingReport && <FundingReport onClose={handleClose} />}
      {showVideosAdmin && <VideosAdmin onClose={handleClose} />}
      {showDonatePopup && <Donate onClose={handleClose} />}
      {showCharityAdmin && <CharityAdmin onClose={handleClose} />}
      {showCharityReport && <CharityReport onClose={handleClose} />}
      {showVotedBillsReport && <VotedBillsReport onClose={handleClose} />}
      {showCandidatesAdmin && <AdminCandidatesPopup isOpen={showCandidatesAdmin} onClose={handleClose} />}
      {showReceiptReport && <ReceiptReport onClose={handleClose} />}

      {/* Add Quiz component */}
      {showQuiz && (
        <Quiz onClose={() => setShowQuiz(false)} />
      )}
    </header>
  );
};

export default Header;
